import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AppState } from '../../store';
import { selectAccountId } from '../../account/store/account.selectors';
import { ConnectionType } from '../connection.models';
import { QueryParams } from '../../models/http.models';
import { environment } from '../../../environments/environment';
import { ListParams } from '../../common/helper/query-params-generic-list.helper';

@Injectable({
  providedIn: 'root',
})
export class ConnectionTypesResource {
  private apiRoot: string = `${environment.API_URL}`;

  constructor(private http: HttpClient, private store: Store<AppState>) {}

  query(params?: ListParams): Observable<ConnectionType[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<ConnectionType[]>(`${this.apiRoot}/${account_id}/api/connections/types`, {
          params: params as QueryParams,
        }),
      ),
    );
  }
}
